import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { FilePicker } from '@capawesome/capacitor-file-picker';
import { inject, Injectable } from '@angular/core';

import { Platform } from '@ionic/angular';

import { Camera } from '@capacitor/camera';
import { StatusBar, Style } from '@capacitor/status-bar';

import { ToastService } from '../toast/toast.service';

@Injectable({
    providedIn: 'root'
})
export class MobileAppService {
    platform = inject(Platform);
    toastService = inject(ToastService);

    android = this.platform.is('android') && this.platform.is('capacitor'); //Check if it is a mobile app on android
    ios = this.platform.is('ios') && this.platform.is('capacitor'); //Check if it is a mobile app on ios
    mobileApp = this.platform.is('capacitor'); //Check if it is a mobile app

    //Sets Edge to Edge background to Dark for Android
    //Sets a white status bar for iOS
    async setDarkEdgeToEdge() {
        if (!this.mobileApp) return;

        if (this.android) {
            await EdgeToEdge.setBackgroundColor({ color: '#1B1A1f' });
            await StatusBar.setBackgroundColor({ color: '#1B1A1f' });
            await StatusBar.setStyle({ style: Style.Dark });
        } else if (this.ios) {
            await StatusBar.setBackgroundColor({ color: '#FFFFFF' });
            await StatusBar.setStyle({ style: Style.Light });
        }
    }

    //Sets Edge to Edge background to white
    async setLightEdgeToEdge() {
        if (!this.mobileApp) return;

        if (this.android) {
            await EdgeToEdge.setBackgroundColor({ color: '#FFFFFF' });
        }

        await StatusBar.setBackgroundColor({ color: '#FFFFFF' });
        await StatusBar.setStyle({ style: Style.Light });
    }

    //Sets status bar to orange with a dark Edge to Edge setting and statusbar text for a dark background
    //StatusBar.setBackgroundColor is not working for Android, so it should use the Edge to Edge color
    async setOrangeEdgeToEdge() {
        if (!this.mobileApp) return;

        if (this.android) {
            await EdgeToEdge.setBackgroundColor({ color: '#1B1A1f' });
            await StatusBar.setStyle({ style: Style.Dark });
        } else if (this.ios) {
            await StatusBar.setBackgroundColor({ color: '#F56F10' });
            await StatusBar.setStyle({ style: Style.Light });
        }
        // const value = await StatusBar.getInfo();
    }

    async hasCameraPermission(showDeniedToast: boolean = true) {
        if (this.android) {
            const permissions = await Camera.checkPermissions();

            if (permissions.camera === 'denied' || permissions.photos === 'denied') {
                const requestPermission = await Camera.requestPermissions();
                if (requestPermission.camera === 'denied' && permissions.photos === 'denied') {
                    if (showDeniedToast) {
                        this.toastService.errorToast({
                            message: 'Please allow access in order to be able to select an image.',
                            duration: 5000
                        });
                    }

                    return false;
                }
            }
        }
        return true;
    }

    async hasFilesPermission(showDeniedToast: boolean = true) {
        if (this.android) {
            const permissions = await FilePicker.checkPermissions();

            if (permissions.accessMediaLocation === 'denied' || permissions.readExternalStorage === 'denied') {
                const requestPermission = await FilePicker.requestPermissions();
                if (
                    requestPermission.accessMediaLocation === 'denied' &&
                    permissions.readExternalStorage === 'denied'
                ) {
                    if (showDeniedToast) {
                        this.toastService.errorToast({
                            message: 'Please allow access in order to be able to select a file.'
                        });
                    }
                    return false;
                }
            }
        }
        return true;
    }
}
